/* eslint-disable no-extra-parens */
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import React, { useState } from 'react';
import {
  ProgressCircle, Search, SearchResult, SearchResults,
} from '@americanexpress/dls-react';
import { callApi } from '../../../utils';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormSearchItem = React.memo(({
  formField, pageData, setPageData, acsMgmt, loginData,
}) => {
  const [showError, setShowError] = useState(false);
  const [, setShowDropDown] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [suggestionList, setSuggestionList] = useState([]);

  const {
    id, name, disabled, value, apiResultFiledNm,
  } = formField;

  const renderResults = () => (
    <SearchResults
      id={`SearchResults-${name}`}
      css={advFormStyles['.searchResults']}
    >
      {suggestionList.map((data, i) => (
        <SearchResult
          name={name}
          value={data[apiResultFiledNm]}
          key={data[apiResultFiledNm]}
          id={`SearchResult-${name}-${i}`}
          css={advFormStyles['.searchResult']}
        >
          <p className="pad-1">
          {data[apiResultFiledNm]}
          </p>
        </SearchResult>
      ))}
    </SearchResults>
  );

  const renderLoader = () => (
    <div id="advFormSearch-searchLoading-container" css={advFormStyles['.searchLoading']}>
      <ProgressCircle id="advFormSearch-searchLoading" css={advFormStyles['.loading']} />
    </div>
  );

  const renderError = () => (
    <SearchResults
      id="SearchResults-error"
      css={advFormStyles['.searchResults']}
    >
      <SearchResult
        key="error"
        id="SearchResult-error"
        css={advFormStyles['.searchResult']}
        disabled={true}
        onClick={() => {}}
      >
        <p css={advFormStyles['.searchErrorMsg']}>
          Results could not be fetched due to an error
        </p>
      </SearchResult>
    </SearchResults>
  );

  const handleOnResultsClose = () => {
    setShowError(false);
    setShowLoader(false);
    setSuggestionList([]);
    setShowDropDown(false);
  };

  const handleOnResultSelect = (event, currId) => {
    const currValue = event.target.textContent;
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[currId].value = currValue;
    setSuggestionList([]);
    setPageData(updatedPageData);
  };

  // eslint-disable-next-line max-params
  const handleFormFieldData = async (apiPath, apiFullPath, currVal, apiHelper) => {
    setShowDropDown(true);
    setShowLoader(true);
    setSuggestionList([]);
    const apiEndPoint = apiFullPath || (acsMgmt + apiPath + currVal);
    const { data, error } = apiHelper ? await apiHelper(apiEndPoint, 'GET', undefined)
      : await callApi(apiEndPoint, 'GET', undefined, loginData);

    if (!error) {
      if (typeof data !== 'undefined' && data !== null) {
        setShowDropDown(false);
        setShowLoader(false);
        setSuggestionList(data);
      } else {
        setShowError(true);
      }
    } else {
      setShowError(true);
    }
  };

  const handleOnChange = (event, currId) => {
    const updatedPageData = { ...pageData };
    // eslint-disable-next-line no-shadow
    const { value } = event.target;
    updatedPageData.formFields[currId].value = value;
    setPageData(updatedPageData);
    // eslint-disable-next-line no-shadow
    const {
      // eslint-disable-next-line no-shadow
      name, apiPath, apiFullPath, apiCallHelper,
    } = updatedPageData.formFields[currId];
    let limit = 3;
    if (name === 'iiqEntitlementNm') {
      limit = 12;
    }
    if (value.length >= limit) {
      handleFormFieldData(apiPath, apiFullPath, value, apiCallHelper);
    } else {
      setShowDropDown(false);
      setShowLoader(false);
      setSuggestionList([]);
    }
  };

  const style = css`
  & > form > div > button {
    z-index: auto;
  }
`;

  return (
    <div css={style}>
      <Search
        id={name}
        status={`${showError ? 'error' : ''}`}
        name={name}
        data-id={id}
        value={value}
        disabled={disabled}
        onResultsClose={() => handleOnResultsClose()}
        onResultSelect={(event) => handleOnResultSelect(event, id)}
        onChange={(event) => handleOnChange(event, id)}
        aria-labelledby={`lbl-${name}`}
      >
        {showError
          ? renderError()
          : (showLoader
            ? renderLoader()
            : renderResults())}
      </Search>
    </div>
  );
});

export default AdvFormSearchItem;
